import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: 26%;
  .p-relative {
    position: relative;
  }
  .s {
    font-style: normal;
    font-weight: 700;
    font-size: 17px;
    line-height: 22px;
    color: #707070;
  }
  .mb-0 {
    width: 169px;
    height: 38px;
    color: #707070;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 19px;
    display: flex;
    align-items: center;
    letter-spacing: -0.0241176em;
  }
  .m-1 {
    height: 150px;
  }
  .me-1 {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 19px;
    display: flex;
    align-items: center;
  }
  .h6 {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 26px;
    /* identical to box height */

    display: flex;
    align-items: center;
    color: #414142;
  }
  .dot {
    width: 11px;
    height: 11px;
    border-radius: 25px;
    background-color: #8676ff;
  }
  .dot-2 {
    background-color: #96d9ff !important;
  }
  .dot-3 {
    background-color: #ffba69 !important;
  }
  .font-weight-700 {
    font-weight: 700;
  }

  @media (max-width: 988px) {
    display: unset;
    height: 23%;
  }

  @media (max-width: 767px) {
    margin-left: 20px;
    height: auto;
  }
  #SvgjsPath1166 {
    border-radius: 20px;
  }
`;
